<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { getPk, getTable } from "./apis/public";
export default {
  data() {
    return {
      ispk: false,
    };
  },
  async created() {
    if (
      sessionStorage.getItem("webIp") == null ||
      sessionStorage.getItem("webIp") == ""
    ) {
      await this.getWebIp();
    }
    await this.getPublicPK();
    this.getPublicTable();
  },
  methods: {
    async getPublicPK() {
      let { pk, token } = await getPk();
      this.ispk = true;
      sessionStorage.setItem("trip", pk);
      this.hasPk = true;
      if (token) {
        sessionStorage.setItem("token", token);
        this.getUserInfo();
      } else {
        this.$store.commit("logOut");
      }
    },
    async getUserInfo() {
      const res = await this.$apis.userServe.getUserInfo();
      if (res.resultCode === "200") {
        if (
          res.content.user.customerType === 1 ||
          res.content.user.customerType === 2
        ) {
          this.$store.commit("loginInfo", {
            token: res.data.token,
            hasLogin: true,
            userInfo: res.content,
          });
        } else {
          sessionStorage.removeItem("token");
        }
      }
    },
    async getPublicTable() {
      let res = await getTable();
      this.$store.commit("setTable", res);
    },
    async getWebIp() {
      const fallbackIp = await this.$apis.loginServe.getUserIpConfig();
      sessionStorage.setItem("webIp", fallbackIp || "103.43.184.186");
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  margin: 0 auto;
}

::v-deep .ivu-btn-primary[disabled] {
  color: #fff;
  background-color: #2d8cf0;
  border-color: #2d8cf0;

  &:hover {
    color: #fff;
    background-color: #2d8cf0;
    border-color: #2d8cf0;
  }
}
</style>
